module.exports = __webpack_public_path__ + "static/img/img-features-feature-5-accessibility_cn.85df894.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-5-accessibility_cn.png
// module id = pRxV
// module chunks = 18